import React from 'react';

const ColorDebugger: React.FC = () => {
  const getComputedStyle = (variable: string): string => {
    if (typeof window !== 'undefined') {
      return window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
    }
    return 'N/A';
  };

  const colorVariables = [
    '--color-primary-50',
    '--color-primary-100', 
    '--color-primary-500',
    '--color-primary-600',
    '--color-primary-900',
    '--color-secondary-50',
    '--color-secondary-100',
    '--color-secondary-500',
    '--color-secondary-600',
    '--color-secondary-900',
    '--color-success',
    '--color-warning',
    '--color-error',
    '--color-info'
  ];

  return (
    <div className="p-4 bg-gray-100 rounded-lg">
      <h3 className="text-lg font-medium mb-4">CSS Variable Debugger</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {colorVariables.map((variable) => (
          <div key={variable} className="flex items-center space-x-3">
            <div 
              className="w-8 h-8 rounded border"
              style={{ backgroundColor: `var(${variable})` }}
            />
            <div>
              <div className="font-mono text-sm">{variable}</div>
              <div className="text-xs text-gray-600">{getComputedStyle(variable)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorDebugger; 